import { Box } from '@mui/material';
import { useCompanyRelativePath } from 'ogp/hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Header, LwButton, Page, Toolbox, useFormButtons } from 'redesign';
import { routes } from 'Routes';
import { useAlert } from 'shared/components/alerts';
import { useCreateEmployee } from '../../hooks/use-create-employee';
import { EmployeeForm } from '../employee-form/employee-form';
import { EmployeeFormData } from '../employee-edit/employee-update';
import { resolveContractMinutes } from '../../../../../../../shared/utils/resolve-contract-minutes';
import { EmploymentType } from '../../../../../../../types';

export const EmployeeCreate = () => {
  const formMethods = useForm<EmployeeFormData>({
    defaultValues: { employmentType: 'EMPLOYEE' },
  });
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();
  const { alertSuccess, alertError } = useAlert();
  const mutation = useCreateEmployee();
  const { submitButtonProps, cancelButtonProps } = useFormButtons(mutation.status);

  const handleSubmit = () => {
    formMethods.handleSubmit((data) => {
      const payload = {
        ...data,
        contractMinutes: resolveContractMinutes(data.contractHours),
        employmentType: data.employmentType ?? EmploymentType.EMPLOYEE,
      };
      mutation.mutate(payload, {
        onSuccess: (id) => {
          alertSuccess('Employee created successfully');
          navigate(generatePath(routes.EmployeeDetail, { id }));
        },
        onError: (e) => alertError(e),
      });
    })();
  };

  return (
    <Page
      header={<Header titleText={'Nieuwe werknemer'} />}
      toolbox={
        <Toolbox underline>
          <LwButton onClick={handleSubmit} iconColorMode="stroke" {...submitButtonProps}>
            Maak aan
          </LwButton>
          <LwButton
            onClick={() => navigate(generatePath(routes.Workforce))}
            iconColorMode="fill"
            {...cancelButtonProps}
          >
            Annuleer
          </LwButton>
        </Toolbox>
      }
    >
      <Box width="100%">
        <FormProvider {...formMethods}>
          <EmployeeForm formState="create" isLentEmployee={false} />
        </FormProvider>
      </Box>
    </Page>
  );
};
